// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s_mgND {
  width: 100%;
  font-family: var(--font-family-base);
}

.hPEktk {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Chart/Chart.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb","sourcesContent":[".container {\n  width: 100%;\n  font-family: var(--font-family-base);\n}\n\n.chartWrapper {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `s_mgND`,
	"chartWrapper": `hPEktk`
};
module.exports = ___CSS_LOADER_EXPORT___;
